import { Outlet, useLocation } from "@/lib/router-compat";
import { useEffect } from "react";
import SiteHeader from "@/components/SiteHeader";

import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import ScrollIntentCTA from "@/components/ScrollIntentCTA";
import ExitIntentCapture from "@/components/ExitIntentCapture";
import DraftFollowupToast from "@/components/DraftFollowupToast";
import DiscardDraftPrompt from "@/components/DiscardDraftPrompt";
import ResumeQuoteBanner from "@/components/ResumeQuoteBanner";
import { useFormDraftCapture } from "@/hooks/useFormDraftCapture";
import { useDraftResume } from "@/hooks/useDraftResume";
import { trackPageview } from "@/lib/analytics";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Fire GA4 SPA pageview after route change (defer so document.title updates first)
    const id = window.setTimeout(() => {
      trackPageview(pathname + search);
    }, 0);
    return () => window.clearTimeout(id);
  }, [pathname, search]);
  return null;
};

const Layout = () => {
  // Watches every <form data-capture-draft> for partial entries and fires
  // a "finish your quote" follow-up on exit-intent or 2-min idle.
  useFormDraftCapture();
  // When the URL carries ?resume=1 (from "Finish quote" toast or follow-up
  // email), prefill and focus the matching form fields.
  useDraftResume();
  return (
    <>
      <ScrollToTop />
      <SiteHeader />

      <ResumeQuoteBanner />
      <Outlet />
      <Footer />
      <StickyMobileCTA />
      <ScrollIntentCTA />
      <ExitIntentCapture />
      <DraftFollowupToast />
      <DiscardDraftPrompt />
    </>
  );
};

export default Layout;

